// extracted by mini-css-extract-plugin
module.exports = {"default":"textarea-module__default___equxP","theme_gray":"textarea-module__theme_gray___Ogi+E","theme_secondary":"textarea-module__theme_secondary___3A-Iv"};